import { render, staticRenderFns } from "./MyProgressColumn.vue?vue&type=template&id=2457b534"
import script from "./MyProgressColumn.vue?vue&type=script&lang=js"
export * from "./MyProgressColumn.vue?vue&type=script&lang=js"
import style0 from "./MyProgressColumn.vue?vue&type=style&index=0&id=2457b534&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports